module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='</div>\n	<div class="timeline-item__details">\n		<div class="timeline-item__date">'+
((__t=( formatTime(obj.startDate, 'Do of MMMM') ))==null?'':__t)+
'</div>\n		<div class="timeline-item__user">'+
((__t=( _.get(obj, 'owner.name') ))==null?'':__t)+
'</div>\n\n	</div>\n<div class="timeline-item__content">\n	<div class="timeline-item-content__title">Scheduled '+
((__t=( obj.type ))==null?'':__t)+
' change\n	<div class="timelinte-item-content__actions">	<span class="m-icon-btn icon-edit js-edit"></span></div>\n\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/schedules/list/templates/timeline-list-item.html
// module id = 466
// module chunks = 0